"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const columns = __importStar(require("../../../columns"));
const headerType = __importStar(require("../../../header/type"));
let seqId = -1;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function newEmptyHeaderData() {
    return {
        id: seqId--,
        define: {},
        headerType: headerType.of(null),
    };
}
exports.newEmptyHeaderData = newEmptyHeaderData;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function newEmptyColumnData() {
    return {
        id: seqId--,
        define: {},
        columnType: columns.type.of(null),
        style: null,
    };
}
exports.newEmptyColumnData = newEmptyColumnData;
class EmptyDataCache {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.headers = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.columns = [];
    }
    getHeader(col, row) {
        const rows = this.headers[row] || (this.headers[row] = []);
        return rows[col] || (rows[col] = newEmptyHeaderData());
    }
    getBody(col, row) {
        const rows = this.columns[row] || (this.columns[row] = []);
        return rows[col] || (rows[col] = newEmptyColumnData());
    }
}
exports.EmptyDataCache = EmptyDataCache;
